// Redux/Reducers/vrShootRequestReducer.js
export const vrShootRequestReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "GET_VR_SHOOT_REQUEST_LIST_REQUEST":
      return { ...state, loading: true, vrShootRequestList: null };

    case "GET_VR_SHOOT_REQUEST_LIST_SUCCESS":
      return { ...state, loading: false, vrShootRequestList: action.payload };

    case "GET_VR_SHOOT_REQUEST_LIST_FAILED":
      return { ...state, loading: false, vrShootRequestList: null, error: action.payload };

    case "GET_VR_SHOOT_REQUEST_REQUEST":
      return { ...state, loading: true, vrShootRequest: null };

    case "GET_VR_SHOOT_REQUEST_SUCCESS":
      return { ...state, loading: false, vrShootRequest: action.payload };

    case "GET_VR_SHOOT_REQUEST_FAILED":
      return { ...state, loading: false, vrShootRequest: null, error: action.payload };

    default:
      return state;
  }
};